<template>
  <modal ref="modal">
    <div id="sub-wrapper">
      <h1>{{ $t('modals.catcher_settings.title') }}</h1>
      <h2>{{ $t('modals.catcher_settings.video_settings.title') }}</h2>
      <p>{{ $t('modals.catcher_settings.video_settings.description') }}</p>
      <select v-model="currentVideoInputDeviceId" v-on:change="onVideoInputDeviceChange">
        <option
          v-for="videoInputDevice in systemVideoInputDevices"
          v-bind:value="videoInputDevice.id"
          v-bind:key="videoInputDevice.id"
        >
          {{ videoInputDevice.label }}
        </option>
      </select>
      <h2>{{ $t('modals.catcher_settings.audio_settings.title') }}</h2>
      <p>{{ $t('modals.catcher_settings.audio_settings.description') }}</p>
      <select v-model="currentAudioInputDeviceId" v-on:change="onAudioInputDeviceChange">
        <option
          v-for="audioInputDevice in systemAudioInputDevices"
          v-bind:value="audioInputDevice.id"
          v-bind:key="audioInputDevice.id"
        >
          {{ audioInputDevice.label }}
        </option>
      </select>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      currentAudioInputDeviceId: null,
      currentVideoInputDeviceId: null,
      systemAudioInputDevices: [],
      systemVideoInputDevices: []
    }
  },
  methods: {

    /**
     * Display the catcher settings modal.
     * @param {string} currentAudioInputDeviceId - ID of the audio device currently used by the catcher.
     * @param {string} currentVideoInputDeviceId - ID of the video device currently used by the catcher.
     * @return {void}
     */
    show (currentAudioInputDeviceId, currentVideoInputDeviceId) {
      this.currentAudioInputDeviceId = currentAudioInputDeviceId
      this.currentVideoInputDeviceId = currentVideoInputDeviceId
      this.initMediaDeviceLists()
      this.$refs.modal.show()
    },

    /**
     * Hide the catcher settings modal.
     * @return {void}
     */
    hide () {
      this.$refs.modal.hide()
    },

    /**
     * Initialize the lists of audio and video devices to display in the
     * settings modal.
     * @return {void}
     */
    async initMediaDeviceLists () {
      try {
        const mediaDevicesInfo = await navigator.mediaDevices.enumerateDevices()
        this.systemAudioInputDevices.length = 0
        this.systemVideoInputDevices.length = 0
        mediaDevicesInfo.forEach(mediaDeviceInfo => {
          switch (mediaDeviceInfo.kind) {
            case 'audioinput':
              this.systemAudioInputDevices.push(this.getInputDeviceInfo(mediaDeviceInfo))
              break
            case 'videoinput':
              this.systemVideoInputDevices.push(this.getInputDeviceInfo(mediaDeviceInfo))
              break
          }
        })
      } catch (error) {
        console.log('Error while enumerating media devices.', error)
      }
    },

    getInputDeviceInfo (mediaDeviceInfo) {
      return {
        id: mediaDeviceInfo.deviceId,
        label: mediaDeviceInfo.label
      }
    },

    /**
     * Event handler called when a new audio device is selected for streaming.
     * @param {Event} event -
     * @returns void
     */
    onAudioInputDeviceChange (event) {
      this.$emit('onAudioInputDeviceChange', event.target.value)
    },

    /**
     * Event handler called when a new video device is selected for streaming.
     * @param {Event} event -
     * @returns void
     */
    onVideoInputDeviceChange (event) {
      this.$emit('onVideoInputDeviceChange', event.target.value)
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  min-width: 30em;
}

h1 {
  margin-top: 0;
}

h2, p {
  text-align: left;
}

</style>
